const Index = {
    hooksTranslations: {
        addAll: 'Todos'
    }
}

const HooksTranslations = Object.assign(Index)

export default HooksTranslations;